import { NavbarMenu } from '@/partials/menu/NavbarMenu';

interface PageMenuProps {
    setActivePage: (page: string) => void; // Define prop type
}

const PageMenu = ({ setActivePage }: PageMenuProps) => {
    const menuItems = [
        { title: 'Candidate Profile', id: 'overview', onClick: () => setActivePage('overview') },
        { title: 'Matched Jobs', id: 'jobs', onClick: () => setActivePage('jobs') }
    ];

    return <NavbarMenu items={menuItems} />;
};

export { PageMenu };
